<template>
  <q-pull-to-refresh @refresh="refresh" class="pullRefresh">
    <div class="approvalOfWarehouseRequests">
      <DataCard
        :data="allFilters"
        :fields="fields"
        :actions="actions"
        @approve="approveRequest"
        @reject="rejectRequest"
        @cardClick="detailRequest"
        @filterR="filterBySupplierName"
        @filterB="filterByBranchCode"
        filterData
      />
    </div>
  </q-pull-to-refresh>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import DataCard from "../../components/DataCard";
export default {
  components: {
    DataCard
  },
  data() {
    return {
      fields: [
        {
          field: "requestNumber",
          label: "",
          type: "string",
          class: "text-bold"
        },
        { field: "", label: "", type: "separator" },
        {
          field: "branch",
          label: "",
          type: "string",
          class: "text-body2"
        },
        {
          field: "amount",
          label: "",
          type: "currency",
          class: "text-overline"
        }
      ],
      actions: [
        {
          label: "Aprovar",
          color: "green",
          icon: "check",
          eventEmit: "approve"
        },
        { label: "Rejeitar", color: "red", icon: "block", eventEmit: "reject" }
      ],
      filterWebR: null,
      filterWebB: null,
      filterR: sessionStorage.filterWebR,
      filterB: sessionStorage.filterWebB
    };
  },
  computed: {
    ...mapState("warehouseRequests", ["warehouse"]),
    allFilters() {
      let requests = this.warehouse;

      switch (sessionStorage.sortWeb) {
        case "sSmLg":
          requests.sort((a, b) => a.amountOfRequest - b.amountOfRequest);
          break;
        case "sLgSm":
          requests.sort((a, b) => b.amountOfRequest - a.amountOfRequest);
          break;
        case "sNewOld":
          requests.sort((a, b) => b.issueDate - a.issueDate);
          break;
        case "sOldNew":
          requests.sort((a, b) => a.issueDate - b.issueDate);
          break;
      }

      if (this.filterR) {
        requests = requests.filter(req => {
          return req.requestNumber.trim().indexOf(this.filterR.trim()) >= 0;
        });
      }

      if (this.filterB) {
        if (sessionStorage.filterWebB) {
          requests = requests.filter(req => {
            return (
              req.branchCode.trim().indexOf(sessionStorage.filterWebB.trim()) >=
              0
            );
          });
        } else {
          requests = requests.filter(req => {
            return req.branchCode.trim().indexOf(this.filterB.trim()) >= 0;
          });
        }
      }

      return requests.map(req => {
        return {
          id: req.id,
          branch: `${req.branchCode} - ${req.branchName}`,
          amount: req.amountOfRequest,
          issueDate: req.issueDate,
          requestNumber: req.requestNumber
        };
      });
    }
  },
  methods: {
    ...mapActions("warehouseRequests", [
      "getWarehouseRequests",
      "approvesRejectsWarehouseRequest"
    ]),
    ...mapMutations("shared", ["setNotification"]),
    approveRequest(request) {
      this.sendResponse(request, "approved", "APROVAR", "text-green");
    },
    rejectRequest(request) {
      this.sendResponse(request, "rejected", "REJEITAR", "text-red");
    },
    sendResponse(request, response, text, classMessage) {
      this.$q
        .dialog({
          title: `Confirmação`,
          message: `Deseja realmente <span class="${classMessage}">${text}</span> a Solicitação ${request.requestNumber}?`,
          html: true,
          ok: {
            push: true,
            color: "green",
            label: "Sim"
          },
          cancel: {
            push: true,
            color: "red",
            label: "Não"
          },
          persistent: true
        })
        .onOk(async () => {
          try {
            await this.approvesRejectsWarehouseRequest({ request, response });
            this.setNotification({
              message: "Resposta enviada com sucesso.",
              color: "green",
              position: "top"
            });
            this.getWarehouseRequests();
          } catch (error) {
            this.setNotification({
              message: error.message,
              color: "red",
              position: "top"
            });
          }
        });
    },
    detailRequest(requestId) {
      this.$router.push({
        name: "warehouseDetail",
        params: { requestId }
      });
    },
    filterBySupplierName(filterR) {
      this.filterR = filterR;
    },
    filterByBranchCode(filterB) {
      if (sessionStorage.filterWebB && !filterB) {
        this.filterB = sessionStorage.filterWebB;
      } else {
        this.filterB = filterB;
        sessionStorage.setItem("filterWebB", filterB);
      }
    },
    async refresh(done) {
      await this.getWarehouseRequests();
      done();
    }
  },
  created() {
    this.getWarehouseRequests();
  }
};
</script>
<style lang="scss">
.approvalOfWarehouseRequests {
  width: 100%;
}
</style>
